import { useMemo } from 'react';
import {
  useGetTenant,
  useListOrganizations,
  useListPayersForTenant,
} from '@/api/trafikportalen';
import { isOrganizationInactiveBeyondPayerListThreshold } from '@/helpers/organizationStatus';

export const useIncompletePayersCount = (enabled = true): number => {
  const { data: tenant } = useGetTenant({
    query: { enabled },
  });
  const { data: organizations } = useListOrganizations({
    query: { enabled },
  });
  const { data: payers } = useListPayersForTenant({
    query: { enabled },
  });

  const incompletePayersCount = useMemo(() => {
    if (!tenant || !organizations || !payers) return 0;

    return payers.reduce((count, payer) => {
      const organization = organizations.find(
        (org) => org.id === payer.organization_id,
      );

      if (!organization) return count;

      if (isOrganizationInactiveBeyondPayerListThreshold(organization)) {
        return count;
      }

      const requiredProps = organization.is_internal
        ? tenant?.required_internal_invoicing_details
        : tenant?.required_external_invoicing_details;

      const missingProps = requiredProps?.filter(
        (prop) => !payer.details[prop],
      );

      return count + (missingProps?.length > 0 ? 1 : 0);
    }, 0);
  }, [tenant, organizations, payers]);

  return incompletePayersCount;
};
